import { useEffect, useState } from 'react';
import { useSetImmerAtom } from 'jotai-immer';
import { tableFiltersVM, tableStatsVM, tableViewVM } from '../../../../core/table/table_view_models';
import { FEEDS_LIST_STORAGE_KEY, FEEDS_LIST_VIEW_KEY } from '../../feeds_const';
import {
    tableStateAtom,
    tableViewAtom,
    feedsDataAtom,
    tableStatsAtom,
    tableFiltersAtom,
    setAtomFeedsListTableViewState,
} from '../feeds_list_atoms';
import { feedsListAllColumnsView, feedsListColumnSpec } from './FeedsListTableSpec';
import viewStateRepo from '../../../../core/repo/viewStateRepo';
import { tableDataVM, tableStateVM } from '../../../../core/table/table_view_models';
import { FeedsDataItem } from '../feeds_list_types';
import { ListTableInitHookReturn } from '../../../../core/table/table.types';
// import { useFeedsStore } from '../pagehooks/useFeedsStore';
// import { getFeedsInitialView } from './getFeedsInitialView';
import {
    tblSpecLoadStorage,
    tblSpecLoadView,
    // initializeSessionViewsStorage,
} from '../../../../core/table/tableViewsRepo';

export const useFeedsListTableInit = (): ListTableInitHookReturn => {
    const [init, setInit] = useState(true);
    // const pageStore = useFeedsStore();
    const setState = useSetImmerAtom(tableStateAtom);
    const setView = useSetImmerAtom(tableViewAtom);
    const setList = useSetImmerAtom(feedsDataAtom);
    const setStats = useSetImmerAtom(tableStatsAtom);
    const setFilter = useSetImmerAtom(tableFiltersAtom);

    // INIT
    useEffect(() => {
        // const initializeAsync = async (): Promise<void> => {
        //     try {
        //         await initializeSessionViewsStorage(FEEDS_LIST_VIEW_KEY);
        //     } catch (error) {
        //         console.warn('⚠️ Failed to initialize session storage:', error);
        //     }
        // };

        setState(draft => {
            if (init && !draft.waiting) {
                setInit(false);
                // initializeAsync();
                // try {
                const colSpec = feedsListColumnSpec();

                // TODO: Swap this back out later.
                // const defaultView = getFeedsInitialView();
                const defaultView = feedsListAllColumnsView();
                console.log('[FeedsTableInit] defaultView.sortby:', defaultView.sortby);

                const savedViews = tblSpecLoadStorage(FEEDS_LIST_VIEW_KEY, colSpec, defaultView);
                draft.views = savedViews.views;
                draft.currentViewId = savedViews.current;
                console.log(
                    '[FeedsTableInit] savedViews.current:',
                    savedViews.current,
                    'views count:',
                    savedViews.views.length,
                );

                const loadedView = tblSpecLoadView(savedViews.current, savedViews.views, colSpec) || tableViewVM();
                console.log('[FeedsTableInit] loadedView sort after tblSpecLoadView:', JSON.stringify(loadedView.sort));
                setView(() => loadedView);

                const viewstate = viewStateRepo.getTable(FEEDS_LIST_STORAGE_KEY, Array.from(colSpec.keys()));
                console.log(
                    '[FeedsTableInit] persisted viewstate:',
                    viewstate
                        ? JSON.stringify({
                              sort: viewstate.sort,
                              hasFlt: !!viewstate.flt,
                              hasPaging: !!viewstate.paging,
                          })
                        : 'null',
                );
                if (!!viewstate) {
                    // Only restore persisted sort if it has a valid column and direction.
                    // Prevents a race condition where useFeedsListDestroy persists empty sort
                    // after useFeedsListTableInit cleanup has already reset the atoms.
                    if (
                        viewstate.sort &&
                        typeof viewstate.sort.col === 'string' &&
                        viewstate.sort.col !== '' &&
                        typeof viewstate.sort.dir === 'string' &&
                        (viewstate.sort.dir === 'ASC' || viewstate.sort.dir === 'DSC')
                    ) {
                        console.log('[FeedsTableInit] Restoring persisted sort:', JSON.stringify(viewstate.sort));
                        setView(draft => {
                            draft.sort = viewstate.sort;
                        });
                    } else {
                        console.log(
                            '[FeedsTableInit] Persisted sort INVALID, skipping. sort:',
                            JSON.stringify(viewstate.sort),
                        );
                    }
                    setFilter(() => viewstate.flt);
                    setStats(draft => {
                        draft.paging = viewstate.paging;
                    });
                }
                return draft;
                //         if (!Array.isArray(savedViews.views)) {
                //             draft.views = [defaultView];
                //             draft.currentViewId = defaultView.key;
                //         } else if (savedViews.views.length === 0) {
                //             draft.views = [defaultView];
                //             draft.currentViewId = defaultView.key;
                //         } else {
                //             const hasValidDefault = savedViews.views.some(
                //                 v => v.key === defaultView.key || v.key === 'default' || v.key === '1',
                //             );
                //             if (!hasValidDefault) {
                //                 savedViews.views.unshift(defaultView);
                //             }
                //             // draft.views = savedViews.views;
                //             // draft.currentViewId = savedViews.current;
                //             draft.views = [defaultView];
                //             draft.currentViewId = defaultView.key;
                //         }
                //         const currentView = tblSpecLoadView(draft.currentViewId, draft.views, colSpec);
                //         if (!currentView || !currentView.cols || currentView.cols.length === 0) {
                //             const basicView = tableViewVM();
                //             basicView.cols = Array.from(colSpec.values());
                //             setView(() => basicView);
                //         } else {
                //             setView(() => currentView);
                //             const currentViewSpec = draft.views.find(v => v.key === draft.currentViewId);
                //             if (
                //                 currentViewSpec &&
                //                 typeof currentViewSpec.pgsize === 'number' &&
                //                 currentViewSpec.pgsize > 0
                //             ) {
                //                 setStats(draftStats => {
                //                     draftStats.paging.size =
                //                         typeof currentViewSpec.pgsize === 'number' ? currentViewSpec.pgsize : 50;
                //                 });
                //             }
                //         }
                //         const viewstate = viewStateRepo.getTable(FEEDS_LIST_STORAGE_KEY, Array.from(colSpec.keys()));
                //         if (
                //             !!viewstate &&
                //             viewstate.sort != null &&
                //             typeof viewstate.sort.col === 'string' &&
                //             viewstate.sort.col !== '' &&
                //             typeof viewstate.sort.dir === 'string' &&
                //             viewstate.sort.dir !== ''
                //         ) {
                //             setView(draft => {
                //                 draft.sort = viewstate.sort;
                //             });
                //         }
                //         if (!!viewstate) {
                //             setFilter(() => viewstate.flt);
                //             setStats(draft => {
                //                 draft.paging = viewstate.paging;
                //             });
                //         }
                //     } catch (error) {
                //         const colSpecFallback = feedsListColumnSpec();
                //         const fallbackView = tableViewVM();
                //         fallbackView.cols = Array.from(colSpecFallback.values());
                //         setView(() => fallbackView);
                //     }
                //     return draft;
                // } else if (draft.init && draft.waiting && !pageStore.loading) {
                //     draft.init = false;
                //     draft.waiting = false;
                //     return draft;
                // } else {
                //     return draft;
            }
        });
        /* eslint-disable-next-line */
    }, []);

    // Cleanup only on unmount, not on every init, waiting or loading change (infinite loop)
    useEffect(() => {
        // destroy
        return (): void => {
            setAtomFeedsListTableViewState();
            setState(() => tableStateVM());
            setView(() => tableViewVM());
            setFilter(() => tableFiltersVM());
            setStats(() => tableStatsVM());
            setList(() => tableDataVM<FeedsDataItem>());
        };
    }, [setFilter, setList, setState, setStats, setView]); // Include dependencies but comment explains this is for unmount cleanup

    return { init };
};
